import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import HerePolyline from 'shared/hereMap/HerePolyline';
import { useHereMap } from '../../../views/shared/hereMap/HereMapContext';
import { getCenterFromPolylines, getBBoxFromPolylines } from '../route/helpers';
import isArray from 'lodash/isArray';

function HereMultiRoutes({
  positions,
  color,
  weight,
  onClick,
  zIndex,  
  offset,
  type,
  centerOnChange,
  onContextMenu,
}) {
  const { map } = useHereMap();

  useEffect(() => {
    if (centerOnChange && isArray(positions) && positions.length > 0) {
      const bounds = getBBoxFromPolylines(positions);
      const viewModal = map.getViewModel();
      if (viewModal.getLookAtData().bounds.getBoundingBox().containsRect(bounds)) {
        map.setCenter(getCenterFromPolylines(positions), true);
      } else {
        viewModal.setLookAtData({
          bounds: bounds
        });
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [positions]);

  const style = { strokeColor: color, lineWidth: weight };
  return (<>
    {
    positions.map((position, id) => <HerePolyline
      key={`HerePolyline${id}`}
      latLngs={position} 
      options={{ zIndex, style, offset }}
      changeCursorOnHover
      onTap={onClick}
      onContextMenu={onContextMenu}
      type={type}
    />)
    }
  </>)
  
}

HereMultiRoutes.propTypes = {
  color: PropTypes.string.isRequired,
  weight: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  onContextMenu: PropTypes.func,
  changeCursorOnHover: PropTypes.bool,
  centerOnChange: PropTypes.bool,
  zIndex: PropTypes.number,
};

export default HereMultiRoutes;
